var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"patent-pending"},[_vm._v("\n  "+_vm._s(_vm.$l.patentPending)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }